// extracted by mini-css-extract-plugin
module.exports = {"tenantItem":"SelectTenantCard_tenantItem__3cBfd","sectionFloor":"SelectTenantCard_sectionFloor__3DFwq"};